export class Language {
    name:string;
    iso:string;

    constructor(language:any) {
        this.name = language.name;
        this.iso = language.iso;
    }
}